import { Sun, Moon } from 'lucide-react'
import { useUIStore } from '@/stores/ui.store'

type Palet = 'inova' | 'modern' | 'klasik' | 'ferah' | 'indigo' | 'emerald' | 'rose' | 'amber' | 'slate'

const PALETLER: { id: Palet; label: string; renk: string; aciklama: string }[] = [
  { id: 'inova',   label: 'iNova',   renk: '#F97316', aciklama: 'Turuncu, minimal'  },
  { id: 'modern',  label: 'Modern',  renk: '#ff7851', aciklama: 'Turuncu, sıcak'   },
  { id: 'klasik',  label: 'Klasik',  renk: '#2563EB', aciklama: 'Mavi, slate'       },
  { id: 'ferah',   label: 'Ferah',   renk: '#006171', aciklama: 'Teal, editorial'   },
  { id: 'indigo',  label: 'Indigo',  renk: '#4F46E5', aciklama: 'Mor-indigo'        },
  { id: 'emerald', label: 'Emerald', renk: '#059669', aciklama: 'Yeşil, taze'       },
  { id: 'rose',    label: 'Rose',    renk: '#E11D48', aciklama: 'Kırmızı, canlı'    },
  { id: 'amber',   label: 'Amber',   renk: '#D97706', aciklama: 'Altın, enerjik'    },
  { id: 'slate',   label: 'Slate',   renk: '#475569', aciklama: 'Nötr, minimal'     },
]

export function ThemeSwitcher() {
  const { tema, toggleTema, palet, setPalet } = useUIStore()

  return (
    <div className="space-y-5">
      {/* Renk Paleti */}
      <div>
        <p className="text-xs text-text-muted font-medium uppercase tracking-wider mb-3">
          Renk Paleti
        </p>
        <div className="grid grid-cols-4 gap-2">
          {PALETLER.map((p) => (
            <button
              key={p.id}
              onClick={() => setPalet(p.id)}
              title={`${p.label} — ${p.aciklama}`}
              className={`flex flex-col items-center gap-1.5 p-2 rounded-lg border-2 transition-all ${
                palet === p.id
                  ? 'border-primary bg-primary/5'
                  : 'border-bg-border hover:border-bg-border/60 hover:bg-bg-elevated'
              }`}
            >
              <span
                className="w-6 h-6 rounded-full transition-all"
                style={{
                  backgroundColor: p.renk,
                  boxShadow: palet === p.id
                    ? `0 0 0 2px white, 0 0 0 4px ${p.renk}`
                    : '0 0 0 2px transparent',
                }}
              />
              <span className="text-xs text-text-secondary leading-none">{p.label}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Renk Modu */}
      <div>
        <p className="text-xs text-text-muted font-medium uppercase tracking-wider mb-3">
          Renk Modu
        </p>
        <div className="flex gap-2">
          <button
            onClick={() => tema === 'dark' && toggleTema()}
            className={`flex flex-1 items-center justify-center gap-2 px-4 py-2.5 rounded-lg border text-sm font-medium transition-colors ${
              tema === 'light'
                ? 'bg-primary/10 border-primary/40 text-primary'
                : 'bg-bg-elevated border-bg-border text-text-secondary hover:text-text-primary hover:bg-bg-border'
            }`}
          >
            <Sun className="w-4 h-4" />
            Açık
          </button>
          <button
            onClick={() => tema === 'light' && toggleTema()}
            className={`flex flex-1 items-center justify-center gap-2 px-4 py-2.5 rounded-lg border text-sm font-medium transition-colors ${
              tema === 'dark'
                ? 'bg-primary/10 border-primary/40 text-primary'
                : 'bg-bg-elevated border-bg-border text-text-secondary hover:text-text-primary hover:bg-bg-border'
            }`}
          >
            <Moon className="w-4 h-4" />
            Koyu
          </button>
        </div>
      </div>
    </div>
  )
}
